export const ADMIN_JIRA_MACRO_REPAIR_ANALYTICS_SOURCE = 'adminJiraMacroRepair';
export const POLL_INTERVAL_MS = 1000;
export const APP_LINKS_URL = '/wiki/plugins/servlet/applinks/listApplicationLinks';
